import { StyleSheet } from 'react-native';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { neutrals, brand } from 'src/theme/colors';

export const styles = StyleSheet.create({
  sliderContainer: {
    justifyContent: 'center',
    cursor: 'pointer',
  },
  sliderTrack: {
    height: 3,
    backgroundColor: neutrals.coldGrays.marble,
    borderRadius: 25,
    justifyContent: 'center',
    zIndex: 1,
  },
  sliderTrackActive: {
    backgroundColor: brand.main.water,
    position: 'absolute',
    top: -1,
    height: 5,
  },
  sliderTrackActivePositive: {
    left: '50%',
    right: 'auto',
    borderTopLeftRadius: 25,
    borderBottomLeftRadius: 25,
  },
  sliderTrackActiveNegative: {
    right: '50%',
    left: 'auto',
    borderTopRightRadius: 25,
    borderBottomRightRadius: 25,
  },
  sliderHandle: {
    backgroundColor: brand.main.water,
    borderRadius: 100,
    position: 'absolute',
    cursor: 'pointer',
    zIndex: 2,
  },
  sliderHandleHover: {
    backgroundColor: `${brand.main.water}19`,
    borderRadius: 100,
    position: 'absolute',
    cursor: 'pointer',
    zIndex: 1,
  },
  button: {
    borderWidth: 2,
    borderColor: 'transparent',
    position: 'absolute',
    marginTop: -4,
    marginLeft: -4,
  },
  buttonFocus: {
    borderColor: FOCUS_COLOR,
  },
});
